import React, { createContext, useContext } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTE_PREFIX, ROUTES } from "./helpers/RoutingHelpers";

const ModuleContext = createContext();

export function useModuleContext() {
  return useContext(ModuleContext);
}

export function ModuleProvider({ children }) {
  const history = useHistory();

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [idForDelete, setIdForDelete] = useState(null);

  const deleteModalProps = {
    deleteModalShow,
    idForDelete,
    openDeleteDialog: (id) => {
      setIdForDelete(id);
      setDeleteModalShow(true);
    },
    closeDeleteDialog: () => {
      setIdForDelete(null);
      setDeleteModalShow(false);
    },
  };
  const [currentData, setCurrentData] = useState(null);
  //   const getDetailsPath = id => `${ROUTE_PREFIX}/${id}/details`
  const value = {
    ...deleteModalProps,
    depositsButtonClick: () => {
      history.push(ROUTES.depositsList.path);
    },
    transactionsButtonClick: () => {
      history.push(ROUTES.transactionsList.path);
    },
    // savedClick: ()=> { history.push(ROUTES.saved.path); },
    listClick: () => {
      //wallets list
      history.push(ROUTES.list.path);
    },
    //TODO use current data for speed
    openEditPage: (id, resource = null, data = null) => {
      if (data) setCurrentData(data);
      resource
        ? history.push(`${ROUTE_PREFIX}/${resource}/${id}/edit`)
        : history.push(`${ROUTE_PREFIX}/${id}/edit`);
    },
    // openDetailsPage: (id) => { history.push(getDetailsPath(id)); },

    // getDetailsPath
  };

  return (
    <ModuleContext.Provider value={{ value, currentData }}>
      {children}
    </ModuleContext.Provider>
  );
}
